import millify from "millify";
import RowItem from "components/shareable/RowItem";
import { Body2 } from "components/shareable/Typography";
import Loader from 'elements/Loader';
import useCurrentBrand from 'Hooks/useCurrentBrand';
import UnlockDataBanner from "components/shareable/UnlockDataBanner";
import UnlockPresavesByDayImage from 'assets/images/unlock-presaves-by-day.svg';
import CardSymphony from "elements/CardSymphony";
import Sty from "modules/Sty";
import { makeKey } from "modules/Utils";

export interface PresaveStreamingServiceDemographicsItem {
    name: string;
    platform: string;
    tier?: string;
    count: number;
    percentage: number;
    icon?: string;
}
interface DemographicsStatsProps {
    shown: boolean;
    contentName: string;
    demographicBreakdown: PresaveStreamingServiceDemographicsItem[],
    children?: any,
    isLoading: boolean
}

export const Demographics = ({
    shown,
    contentName,
    demographicBreakdown,
    children,
    isLoading
}: DemographicsStatsProps) => {
    const { isPaidBrand: isPaidUser } = useCurrentBrand();

    const renderContent = () => {
        if (!isPaidUser) {
            return (
                <UnlockDataBanner
                    className="demographicsUnlockDataBanner"
                    title="Track which streaming services your fans use to pre-save"
                    description="This feature is only available to Pro or Lite users."
                    image={UnlockPresavesByDayImage}
                    unlockedWithLite
                />
            )
        }

        if (isLoading) {
            return (
                <Loader
                    className="demographicsLoaderPreSave"
                    title="Loading data..."
                    style={{
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    }}
                />
            )
        }

        if (demographicBreakdown.length > 0) {
            return (
                <ul className="max-h-80 overflow-auto">
                    {demographicBreakdown.map((item: PresaveStreamingServiceDemographicsItem, index: number) => {
                        return (
                            <RowItem
                                key={makeKey(item.name, index)}
                                image={item.icon}
                                name={item.name}
                                showRightValue={true}
                                rightValue={`${millify(item.count)} (${item.percentage}%)`}
                            />
                        );
                    })}
                </ul>
            )
        } else {
            return (
                <div style={Sty.text16grey}>
                    No pre-saves have been received yet. Once you share your link and fans start pre-saving, you'll be able to see which streaming services they're using. Start sharing to see this data!
                </div>
            )
        }
    }

    return (
        <>
            <div className={`demographicsComponent pt-0 ${shown ? 'visible' : 'hidden'}`}>
                {!demographicBreakdown ?
                    <div className="mx-auto my-6 flex-col flex items-center ">
                        <Loader className="demographicsLoaderPreSave" title="Loading Demographics..." />
                    </div>
                    :
                    <>
                        <CardSymphony
                            className="demographicsCard"
                            title="Streaming Services Breakdown"
                            subtitle={`These are the streaming services your fans used to pre-save '${contentName}'`}
                            size="small"
                        />
                        <div>
                            {renderContent()}
                        </div>
                    </>
                }
            </div>
            {children}
        </>
    )
}

export default Demographics;